module.exports = __webpack_public_path__ + "graph.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/graph.png
// module id = 2182
// module chunks = 13